
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#6C6C6C"}},[_c('path',{attrs:{"d":"M14.902 1.098a3.75 3.75 0 00-5.304 0L6.464 4.233c-1.515 1.514-1.375 3.928 0 5.303.23.23.485.418.754.572l.572-.572c.375-.375.243-.814.236-1.13a1.81 1.81 0 01-.236-.196c-.705-.705-.737-1.915 0-2.652l3.134-3.134a1.877 1.877 0 012.652 0c.73.731.73 1.92 0 2.652l-2.072 2.072c.06.331.42 1.116.235 2.411.009-.008.02-.014.028-.023l3.135-3.134a3.75 3.75 0 000-5.304z"}}),_c('path',{attrs:{"d":"M9.779 6.22a3.569 3.569 0 00-.754-.572l-.572.572c-.375.376-.243.814-.237 1.13.083.06.163.122.237.196.705.706.737 1.915 0 2.652l-3.377 3.377a1.877 1.877 0 01-2.652 0 1.877 1.877 0 010-2.652L4.74 8.61c-.06-.332-.42-1.117-.235-2.412-.009.009-.02.014-.029.023L1.098 9.598A3.75 3.75 0 006.402 14.9l3.377-3.377c1.486-1.487 1.405-3.898 0-5.304z"}})])])
          )
        }
      }
    